import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import FieldNoteStatus from '@app/models-internal/field-note-status.enum';

import FieldNoteViewModel from '@app/interfaces/field-note-view-model';
import { DatePipe } from '@angular/common';
import { parseISO } from 'date-fns';

@Component({
    selector: 'field-note',
    templateUrl: './field-note.component.html',
    styleUrls: ['./field-note.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatePipe]
})
export class FieldNoteComponent implements OnInit {
  private readonly _componentName = 'FieldNoteComponent';

  public date:Date = parseISO('2017-03-24T16:13');

  public author:string = 'Bill H.';

  public content:string = "Amazing bass fishing!  My 11 year old son and I kayak fished for about 3 hours and pulled 14 bass out.  We fished from about 8am-11am pounding shoreline with poppers and had a blast.  You can drive all the way to the pond and put in where the jon boat is (though I would recommend something with at least the ground clearance of a subaru if you're heading all the way down there).  My son wants to go back again but we have some other properties to hit first.";



  
  private _fieldNote : FieldNoteViewModel ;
  public get fieldNote() : FieldNoteViewModel {
    return this._fieldNote;
  }
  public set fieldNote(v : FieldNoteViewModel) {
    this._fieldNote = v;
  }
  



  constructor() { 
    let x = {} as FieldNoteViewModel;
    x.text = "Amazing bass fishing!  My 11 year old son and I kayak fished for about 3 hours and pulled 14 bass out.  We fished from about 8am-11am pounding shoreline with poppers and had a blast.  You can drive all the way to the pond and put in where the jon boat is (though I would recommend something with at least the ground clearance of a subaru if you're heading all the way down there).  My son wants to go back again but we have some other properties to hit first.";
    x.createdOn = parseISO('2017-03-24T16:13');
    x.statusId = FieldNoteStatus.Approved;
    x.weatherIconUrl = 'https://cdn.outdooraccess.com/oa-assets/images/weather/weather-clouds.svg';
    x.author = 'Chicken Chaser McGee';
    this.fieldNote = x;
  }

  ngOnInit() {
  }

}
